import { render, staticRenderFns } from "./FormSetting_Staff.vue?vue&type=template&id=5ca0ca8e&scoped=true"
import script from "./FormSetting_Staff.vue?vue&type=script&lang=js"
export * from "./FormSetting_Staff.vue?vue&type=script&lang=js"
import style0 from "./FormSetting_Staff.vue?vue&type=style&index=0&id=5ca0ca8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca0ca8e",
  null
  
)

export default component.exports